// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueLazyload from "vue-lazyload";
import Mui from 'vue-awesome-mui';
import {getImg} from "./services/urlService";
import CryptoJS from "crypto-js";
import kkUtil from "./assets/js/kk-util";
import Axios from "axios";

Vue.config.productionTip = false;
let jsKey = CryptoJS.enc.Utf8.parse('ZVqAI6jw54IkfLZH');

Vue.use(VueLazyload, {
    adapter: {
      loaded(listener, Init) {
        let jsUrl;

        if (listener.el.getAttribute('imgtype') === 'vod') {
          //视频图片
          let zoom = listener.el.getAttribute('zoom');
          jsUrl = '/js/' + kkUtil.aesEncryptHex(listener.el.getAttribute('imgpath'), jsKey);
          if (zoom !== null) {
            jsUrl = jsUrl + "/" + zoom;
          }
          jsUrl = jsUrl + '.js';
        }else if(listener.el.getAttribute('imgtype') === 'novel'){
          let zoom = listener.el.getAttribute('zoom');
          let imgId = listener.el.getAttribute('imgpath').substr(5, 24);
          jsUrl = '/js/novel/' + kkUtil.md5(listener.el.getAttribute('booktitle')) + "/" + listener.el.getAttribute('chapternum') + "/" + imgId;
          if (zoom !== null) {
            jsUrl = jsUrl + "/" + zoom;
          }
          jsUrl = jsUrl + '.js';
        }else {
          //漫画图片
          let zoom = listener.el.getAttribute('zoom');
          let imgId = listener.el.getAttribute('imgpath').substr(5, 24);
          jsUrl = '/js/manga/' + kkUtil.md5(listener.el.getAttribute('booktitle')) + "/" + listener.el.getAttribute('chapternum') + "/" + imgId;
          if (zoom !== null) {
            jsUrl = jsUrl + "/" + zoom;
          }
          jsUrl = jsUrl + '.js';
        }
        //拼接imgserver
        jsUrl = getImg(jsUrl);

        //请求加密图片
        Axios.create({
          headers: {
            'Content-Type': 'text/plain'
          },
        }).get(jsUrl).then(res => {
          if (res.status === 200) {
            listener.el.src = "data:image/png;base64," + kkUtil.aesDecrypt(res.data + "", jsKey);
          } else if (res.status === 204) {
            listener.el.src = require('./assets/img/icon-e.png');
          }
        });
      }
    }
  },
  Mui);

/* eslint-disable no-new */
let vueObj = new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js